import configuration from '../configuration.mjs';

export let getPageLanguage = (fallback = 'sv') => {
  return configuration.culture ?? fallback;
};
